import { create } from 'zustand';

// zustand 전역 상태 구조
interface LoadingState {
    open: boolean;
    viewLoading: boolean;
    showLoading: () => void;
    hideLoading: () => void;
    showViewLoading: () => void;
    hideViewLoading: () => void;
}

// 전역 스토어 생성 (zustand)
export const useLoadingStore = create<LoadingState>((set) => ({
    open: false,
    viewLoading: false,
    showLoading: () =>
        set({
            open: true,
        }),
    hideLoading: () => {
        set({
            open: false,
        });
    },
    showViewLoading: () =>
        set({
            viewLoading: true,
        }),
    hideViewLoading: () => {
        set({
            viewLoading: false,
        });
    },
}));
